import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import RequestUrlId from "types/RequestUrlId";

const requests = {
    destroy: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.delete(`/account/applications/${url.id}`, config),
    fetch: (config: AxiosRequestConfig) => api.get(`/account/applications`, config),
    fetchAll: (config: AxiosRequestConfig) => api.get(`/account/applications/all`, config),
    get: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`/account/applications/${url.id}`, config),
    store: (data: object, config: AxiosRequestConfig) =>
        api.post(`/account/applications`, data, config),
    update: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.put(`/account/applications/${url.id}`, data, config),
    patch: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.patch(`/account/applications/${url.id}`, data, config),
};

export default requests;
